import paper from 'paper';
import store from '../store';
import { Path, Tool, Point, PointText, Group } from 'paper';
import PathStyle from '@/services/PathStyle';

const local = {
    point1: null,
    point2: null,
    rule: null,
    texts: [],
    spaceKey:false,
    circle: null,
    intersect: null,
    arrow: null
};

function reverse(s){
    return s.split("").reverse().join("");
}

var createAlignedText = function(str, path, style) {
    if( path.firstSegment.point.x - path.lastSegment.point.x > 0){
        str = reverse(str);
    }
    if (str && str.length > 0 && path) {
        // create PointText object for each glyph
        let size = 0;
        var glyphTexts = [];
        for (var i = 0; i < str.length; i++) {
            glyphTexts[i] = createPointText(str.substring(i, i+1), style);
            glyphTexts[i].justification = "center";
        }
        // for each glyph find center xOffset
        var xOffsets = [0];
        for (var i = 1; i < str.length; i++) {
            var pairText = createPointText(str.substring(i - 1, i + 1), style);
            pairText.remove();
            xOffsets[i] = xOffsets[i - 1] + pairText.bounds.width - 
                glyphTexts[i - 1].bounds.width / 2 - glyphTexts[i].bounds.width / 2;
            size += xOffsets[i];
        }
        // set point for each glyph and rotate glyph aorund the point

        for (var i = 0; i < str.length; i++) {
            var centerOffs = xOffsets[i];
            if (path.length < centerOffs) {
                if (path.closed) {
                    centerOffs = centerOffs % path.length;
                }  else {
                    centerOffs = undefined;
                }
            }
            if (centerOffs === undefined) {
                glyphTexts[i].remove();
            } else {
                let middle = centerOffs + (path.length - size / 4 ) / 2;
                if(middle > 0 && middle < path.length){
                    centerOffs = middle;
                }
                var pathPoint = path.getPointAt(centerOffs);
                glyphTexts[i].point = pathPoint;
                var tan = path.getTangentAt(centerOffs); 
                if(tan.angle > 90 || tan.angle < -90){
                    let angle = 0;
                    let positiv = true;
                    if(tan.angle < 0){
                        positiv = false;
                    }
                    if(positiv){
                        angle = (180 - tan.angle) * -1;
                    }else{
                        angle = (180 + tan.angle);
                    }
                    glyphTexts[i].rotate(angle, pathPoint);
                }else{
                    glyphTexts[i].rotate(tan.angle, pathPoint);
                }
            }
        }
        return glyphTexts;
    }
}

// create a PointText object for a string and a style
var createPointText = function(str, style) {
    var text = new PointText();
    text.content = str;
    if (style) {
        if (style.font) text.font = style.font;
        if (style.fontFamily) text.fontFamily = style.fontFamily;
        if (style.fontSize) text.fontSize = style.fontSize;
        if (style.fontWieght) text.fontWeight = style.fontWeight;
    }
    return text;
}

function changeCursor(cursor) {
    let canvas = document.getElementById('js-editor');
    if (canvas) canvas.style.cursor = cursor;
}

function hitOptions() {
    return {
        segments: false,
        stroke: false,
        curves: true,
        fill: true,
        guide: false,
        class: Path,
        curves: false,
        tolerance: store.getters.mobile ? 15 / store.getters.zoom : 8 / store.getters.zoom,
        match: hitMatchFilter,
    };
}

function hitMatchFilter(hitResult) {
    if (hitResult.item) {
        if(hitResult.item == local.circle || hitResult.item == local.rule){
            return false;
        }else{
            return true;
        }
    }else{
        return true;
    }
}

function textOptions(){
    return{
        fontFamily: 'Open Sans',
        fontWeight: 'bold',
        fontSize: store.getters.mobile ? 20 / store.getters.zoom : 20 / store.getters.zoom
    }
}

function displayArrows(bounds, p1, p2) {
    if (!bounds || bounds.area <= 0 ) return;

    let zoom = store.getters.zoom,
        size = 10 / zoom,
        pgroup = new Group({ name: 'rulerArrows' }),
        cotes = new Group();

    if(Math.abs(Math.abs(bounds.bottom) - Math.abs(bounds.top)) > Math.abs(Math.abs(bounds.left) - Math.abs(bounds.right))){
        cotes.addChildren([
            doubleArrow(
                p1,
                p2,
                size
            )
        ]);
    }else{
        cotes.addChildren([
            doubleArrow(
                p1,
                p2,
                size
            ),
        ]);
    }

    PathStyle.arrow(cotes);
    pgroup.addChild(cotes);

    pgroup.addTo(paper.project.layers.view);
    return pgroup;
}

function doubleArrow(p1, p2, size) {

    let vector = p2.subtract(p1);
    let arrowVector = vector.normalize(size);

    if (vector.length > 4 * size) {
        return new Group([
            new Path([
                p2.add(arrowVector.rotate(135)),
                p2,
                p2.add(arrowVector.rotate(-135))
            ]),
            new Path([
                p1.add(arrowVector.rotate(45)),
                p1,
                p1.add(arrowVector.rotate(-45))
            ])
        ]);
    }
    else {
        return new Group([
            new Path([
                p2.add(arrowVector.rotate(45)),
                p2,
                p2.add(arrowVector.rotate(-45))
            ]),
            new Path([
                p1.add(arrowVector.rotate(135)),
                p1,
                p1.add(arrowVector.rotate(-135))
            ])
        ]);
    }
}

function removeAll(){
    if(local.rule){
        local.rule.remove();
    }
    if(local.texts.length > 0){
        local.texts.forEach(text => {
            text.remove();
        });
        local.texts = [];
    }
    if(local.arrow){
        local.arrow.remove();
    }
    if(local.circle){
        local.circle.remove();
    }
}

function resizeAll(){
    if(local.circle){
        let oldRadius = local.circle.bounds.width / 2;
        let radius = 6 / store.getters.zoom;
        local.circle.scale(radius / oldRadius);
    }
    if(local.texts.length > 0){
        local.texts.forEach(text => {
            text.remove();
        });
        local.texts = createAlignedText(Math.round(local.rule.length).toString()+" mm", local.rule, textOptions());
    }
}

function onMouseMove(event) {
    let intersect = paper.project.hitTest(event.point, hitOptions());
    if(intersect){
        local.intersect = intersect.item;
    }else{
        local.intersect = null;
        if(local.circle){
            local.circle.remove();
            local.circle = null;
        }
    }

    if(local.intersect){
        let nearestPoint = local.intersect.getNearestPoint(event.point);
        if(!local.circle){
            local.circle = new Path.Circle({
                center: new Point(50,50),
                radius: 6 / store.getters.zoom,
                fillColor: '#e83c69'
            });
        }
        let oldRadius = local.circle.bounds.width / 2;
        let radius = 6 / store.getters.zoom;
        local.circle.scale(radius / oldRadius);
        
        local.circle.position = nearestPoint;
    }

    if(local.point1 && !local.point2){
        if(local.rule){
            local.rule.remove();
        }
        if(local.texts.length > 0){
            local.texts.forEach(text => {
                text.remove();
            });
        }
        if(local.arrow){
            local.arrow.remove();
        }
        if(local.circle){
            local.rule = new Path.Line(local.point1, local.circle.bounds.center);
        }else{
            local.rule = new Path.Line(local.point1, event.point);
        }
        local.texts = createAlignedText(Math.round(local.rule.length).toString()+" mm", local.rule, textOptions());
        PathStyle.arrow(local.rule);
    }
}

function onMouseUp(event) {
    changeCursor("default");
    if(event.event.button > 0 || local.spaceKey) {
        event.preventDefault();
        event.stopPropagation();
        return false;
    }
}

function onMouseDown(event){
    if (event.event.button > 0 || local.spaceKey) {
        event.preventDefault();
        event.stopPropagation();
        return false;
    }

    if(!(local.point1)){
        if(local.arrow){
            local.arrow.remove();
        }
        if(local.circle){
            local.point1 = local.circle.bounds.center;
        }else{
            local.point1 = event.point;
        }
    }else{
        if(local.circle){
            local.point2 = local.circle.bounds.center;
        }else{
            local.point2 = event.point;
        }
    }

    if(local.point1 && local.point2){
        if(local.rule){
            local.rule.remove();
        }
        if(local.texts.length > 0){
            local.texts.forEach(text => {
                text.remove();
            });
        }
        local.rule = new Path.Line(local.point1, local.point2);
        local.texts = createAlignedText(Math.round(local.rule.length).toString()+" mm", local.rule, textOptions());
        local.arrow = displayArrows(local.rule.bounds, local.point1, local.point2);
        PathStyle.arrow(local.rule);
        local.point1 = null;
        local.point2 = null;
        local.circle.remove();
        local.circle = null;
        changeCursor('default');
        store.dispatch('setWhiteboardTool', 'selecter');
    }
}

function onMouseDrag(event){
    if((event.event.buttons == 2 || (event.event.buttons == 1 && local.spaceKey) || event.event.buttons == 4) && store.getters.shapes.length){
        var newCenter = event.downPoint.subtract(event.point);
        newCenter = newCenter.add(paper.view.center);
        paper.view.center = newCenter;
        changeCursor("move");
    }
}

function onKeyDown(event){
    if(event.key === "space"){
        local.spaceKey = true;
    }
}

function onKeyUp(event) {
    if(event.key === "space"){
        local.spaceKey = false;
    }
}

export const RulerTool = new Tool({
    name: 'ruler',
    onMouseDown,
    onMouseDrag,
    onMouseMove,
    onMouseUp,
    onKeyDown,
    onKeyUp,
    removeAll,
    resizeAll
});
